// Optimized Slider JavaScript for Performance
(function() {
  'use strict';
  
  // Error handling wrapper
  function safeExecute(fn, context = 'Unknown') {
    try {
      return fn();
    } catch (error) {
      console.warn(`⚠️ Slider error in ${context}:`, error.message);
      return null;
    }
  }
  
  // Performance optimization: Use requestIdleCallback for non-critical operations
  const requestIdleCallback = window.requestIdleCallback || function(cb) {
    return setTimeout(cb, 1);
  };
  
  // Critical performance: Reduce main thread blocking
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  // Optimized image loading with intersection observer
  function initLazyLoading() {
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
              observer.unobserve(img);
            }
          }
        });
      }, {
        rootMargin: '50px 0px',
        threshold: 0.01
      });
      
      document.querySelectorAll('img[data-src]').forEach(img => {
        imageObserver.observe(img);
      });
    }
  }
  
  // Optimized slider functionality
  function initSlider() {
    let currentIndex = 0;
    const slides = document.querySelectorAll('.slide, .footer');
    const slider = document.getElementById('slider');
    let totalSlides = slides.length;
    let isScrolling = false;
    
    if (!slider || slides.length === 0) return;
    
    function moveSlider(index) {
      if (isScrolling) return;
      isScrolling = true;
      
      if (index >= totalSlides) index = totalSlides - 1;
      if (index < 0) index = 0;
      currentIndex = index;
      
      // Use transform3d for hardware acceleration
      slider.style.transform = `translate3d(0, -${currentIndex * 100}vh, 0)`;
      
      setTimeout(() => isScrolling = false, 800);
    }
    
    // Optimized touch handling with passive listeners
    let startY = 0;
    const touchStartHandler = (e) => {
      startY = e.touches[0].clientY;
    };
    
    const touchEndHandler = debounce((e) => {
      const endY = e.changedTouches[0].clientY;
      const diff = startY - endY;
      
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          moveSlider(currentIndex + 1);
        } else {
          moveSlider(currentIndex - 1);
        }
      }
    }, 100);
    
    document.addEventListener('touchstart', touchStartHandler, { passive: true });
    document.addEventListener('touchend', touchEndHandler, { passive: true });
    
    // Optimized wheel handling
    const wheelHandler = debounce((e) => {
      if (e.deltaY > 0) {
        moveSlider(currentIndex + 1);
      } else if (e.deltaY < 0) {
        moveSlider(currentIndex - 1);
      }
    }, 150);
    
    document.addEventListener('wheel', wheelHandler, { passive: true });
    
    // Click handlers for slides
    document.querySelectorAll('.slide').forEach(slide => {
      slide.addEventListener('click', () => {
        const url = slide.getAttribute('data-url');
        if (url) {
          window.location.href = url;
        }
      });
    });
  }
  
  // Initialize when DOM is ready with error handling
  function initializeSlider() {
    safeExecute(() => {
      initSlider();
      requestIdleCallback(initLazyLoading);
    }, 'Slider initialization');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSlider);
  } else {
    initializeSlider();
  }
  
  // Expose for external use
  window.initOptimizedSlider = initSlider;
})();
